import tools from '../../tools';
import type Tool from '../../tools/Tool';
import MenuItemComponent from './components/MenuItemComponent';
import MenuPluginFactory from '../MenuPluginFactory/MenuPluginFactory';

// Command Menu Plugin
// This plugin is used to display a "command menu" when the user types
// a / character in the editor. The command menu typically includes
// a list of common tools that the user can select from and provides
// a way to execute those tools without having to navigate the toolbar
// with the mouse.
// It makes use of MenuPluginFactory.

const CommandMenuPlugin = (commandMenuTools: (typeof Tool)[][]) => {
  return MenuPluginFactory<typeof Tool, (typeof Tool)[]>({
    name: 'command menu',
    triggerCharacter: '/',
    menuItemUniqueKey: 'toolName',
    onSearch: async ({ text, editor, controller }) => {
      return commandMenuTools
        .map((toolGroup) =>
          toolGroup.filter((tool) => {
            if (!tool.toolName.toLowerCase().includes(text)) return false;
            if (!tool.available({ editor, controller })) return false;
            return true;
          })
        )
        .filter((toolGroup) => toolGroup.length > 0);
    },
    onSelect: ({ item: tool, event, editor, controller }) => {
      tools.fireToolAction(tool, event, { editor, controller });
    },
    MenuItemComponent,
  });
};

export default CommandMenuPlugin;
